// 为了和功能组件库的路径一致，做了这个转包。
import IconFont, { IconType as _IconType } from '../Base/IconFont';
export interface IconType extends _IconType {};
export default IconFont;
